import React from "react";
import * as S from "./styled";
import { VARIANT_DEFAULTS } from "./variants";
import { TBadgeProps } from "./types";
import { withTooltip } from "../../hocs";

const Badge: React.FC<TBadgeProps> = React.forwardRef<HTMLDivElement, TBadgeProps>(
    ({ icon = false, iconPosition = "before", text, variant = "default", ...props }, ref) => {
        const { icon: defaultIcon, ...defaults } = VARIANT_DEFAULTS[variant];
        const iconJsx = icon === true ? defaultIcon : icon;

        return (
            <S.Badge ref={ref} {...defaults} {...props}>
                {iconPosition === "before" && iconJsx}
                {text !== null && text !== undefined && <S.Text>{text}</S.Text>}
                {iconPosition === "after" && iconJsx}
            </S.Badge>
        );
    }
);

export default withTooltip(Badge);
